import { render } from "./BlockedAccounts.vue?vue&type=template&id=501e69d6&scoped=true"
import script from "./BlockedAccounts.vue?vue&type=script&lang=js"
export * from "./BlockedAccounts.vue?vue&type=script&lang=js"

import "./BlockedAccounts.vue?vue&type=style&index=0&id=501e69d6&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501e69d6"]])

export default __exports__